import axiosInstance from "../services/axiosInstance";
import * as Endpoints from "../entities/Endpoints";

export const fetchClientCheckInDetailsAPI = async (payload) => {
  const { clientId, checkInDetailsId } = payload;
  try {
    const url = checkInDetailsId
      ? `${Endpoints.GET_CLIENT_CHECK_IN_DETAILS}/${clientId}?CheckInDetailsId=${checkInDetailsId}`
      : `${Endpoints.GET_CLIENT_CHECK_IN_DETAILS}/${clientId}`;

    const response = await axiosInstance.get(url);
    return response.data;
  } catch (error) {
    throw error?.data?.message || "Something went wrong.";
  }
};

export const updateCheckInReadStatusAPI = async (payload) => {
  const { coachId, CheckInDetailsId } = payload;
  try {
    const response = await axiosInstance.patch(
      `${Endpoints.UPDATE_CHECKIN_READ_STATUS}/${coachId}/${CheckInDetailsId}`
    );
    return response.data;
  } catch (error) {
    throw error?.data?.message || "Something went wrong.";
  }
};
